(function () {
  // Hero (first section): text + image fade in on load.
  function initHeroReveal() {
    var hero = document.querySelector('#MainContent > .shopify-section:first-of-type');
    if (!hero) return;

    var textEls = hero.querySelectorAll('.text-block, a.size-style');
    textEls.forEach(function (el, i) {
      el.style.transitionDelay = (i * 100) + 'ms';
    });

    requestAnimationFrame(function () {
      hero.classList.add('is-loaded');
    });
  }

  // Rest of the page: each section fades in as it scrolls into view.
  // A single IntersectionObserver watching whole sections (not individual
  // elements inside them) keeps this cheap regardless of page length.
  function initScrollReveal() {
    var sections = document.querySelectorAll('#MainContent > .shopify-section:not(:first-of-type)');
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (section) {
        section.classList.add('is-loaded');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-loaded');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  function init() {
    initHeroReveal();
    initScrollReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
